"use client";

import styled, { css } from "styled-components";

import {
  VariableComponent,
  ElementFlexProps,
  ElementBackgroundProps,
  ElementPositioningProps,
  ElementShadowProps,
  ElementBorderProps,
  ElementTransitionProps,
} from "../ComponentProps";
import {
  positioningCSS,
  getColor,
  borderCSS,
  getShadow,
  flexCSS,
  getVariations,
  transitionCSS,
} from "../utils";

function variableStyle(props: BoxProps) {
  if (!props.position) {
    props.position = "relative";
  }
  return css`
    background: ${getColor(props.background)};
    background-color: ${p =>
      getColor(p.theme[props.backgroundColor] as string, props.backgroundColor)};
    background-image: ${props.backgroundImage};
    background-size: ${props.backgroundSize};
    background-position: ${props.backgroundPosition};
    overflow: ${props.overflow};
    box-shadow: ${getShadow(props.boxShadow)};
    ${props.aspectRatio &&
    `&:before {
      content: "";
      display: block;
      padding-top: ${props.aspectRatio}%;
    }`};
    ${getVariations(props, variableStyle)}
  `;
}

export type BoxProps = VariableComponent<
  ElementPositioningProps &
    ElementTransitionProps &
    ElementFlexProps &
    ElementBorderProps &
    ElementBackgroundProps &
    ElementShadowProps & {
      aspectRatio?: number;
    }
>;

const Box = styled.div<BoxProps>`
  box-sizing: border-box;
  ${variableStyle}
  ${positioningCSS}
  ${flexCSS}
  ${borderCSS}
  ${transitionCSS}
`;

export default Box;
